// The MCP server name and URL are environment-specific, so they come from the
// labs settings API (see useLabsSettings) rather than being hardcoded here.
export const MCP_DOCS_URL = 'https://docs.sequencehq.com/labs/mcp'

// Path where the Stytch OAuth IdP consent screen is mounted. Must match the
// authorize URL configured in the Stytch dashboard. Kept here so it can be
// swapped without touching the router.
export const IDP_AUTHORIZE_PATH = '/oauth/authorize'

export const CUSTOMER_QUERIES_AGENT_DOCS_URL =
  'https://docs.sequencehq.com/agents/ar-agent'
